import { useMemo } from 'react';
import { CampaignState } from 'modules/domains/campaign';

import {
  DEFAULT_TYPEAHEAD_QUERY_LIMIT,
  DEFAULT_TYPEAHEAD_SORTING,
  DISPLAYED_CAMPAIGN_STATES,
} from '../../../constants';

export const useCampaignsVariables = (
  search?: string,
  ids?: number[],
  page?: number,
  isRecurring?: boolean,
) => {
  return useMemo(
    () => ({
      search,
      ids,
      pagination: {
        ...DEFAULT_TYPEAHEAD_QUERY_LIMIT,
        offset: (page || 0) * DEFAULT_TYPEAHEAD_QUERY_LIMIT.limit,
      },
      sort: DEFAULT_TYPEAHEAD_SORTING,
      campaignFilterInfo: {
        campaignState: isRecurring ? CampaignState.Recurring : DISPLAYED_CAMPAIGN_STATES,
      },
    }),
    [search, ids, page, isRecurring],
  );
};
